import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { ScrollReveal } from "@/components/shared/ScrollReveal";
import { useLang } from "@/i18n/LanguageContext";

export default function FinalCta() {
  const { t } = useLang();
  return (
    <section
      data-testid="final-cta-section"
      className="relative bg-black text-white py-32 md:py-52 border-t border-white/10 overflow-hidden"
    >
      <motion.div
        aria-hidden
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 0.6 }}
        viewport={{ once: true }}
        transition={{ duration: 2 }}
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(circle at 50% 50%, rgba(231,38,31,0.18), transparent 55%)",
        }}
      />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 text-center">
        <ScrollReveal>
          <p className="font-mono-eyebrow text-[var(--dp-accent)] mb-10">{t.finalCta.eyebrow}</p>
        </ScrollReveal>
        <ScrollReveal delay={0.1}>
          <h2 className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-[128px] leading-[0.9] tracking-tighter mb-10 max-w-6xl mx-auto">
            {t.finalCta.title.split(" ").map((w, i) => (
              <span key={i} className={i === 2 ? "font-serif-italic text-[var(--dp-accent)]" : ""}>
                {w}{" "}
              </span>
            ))}
          </h2>
        </ScrollReveal>
        <ScrollReveal delay={0.2}>
          <p className="text-neutral-300 text-lg md:text-xl max-w-2xl mx-auto mb-14 leading-relaxed">
            {t.finalCta.body}
          </p>
        </ScrollReveal>
        <ScrollReveal delay={0.3}>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a
              href="mailto:info@deltapictures.it"
              data-testid="final-cta-primary"
              className="inline-flex items-center gap-3 text-white text-lg md:text-xl link-underline"
            >
              info@deltapictures.it
              <ArrowUpRight size={18} />
            </a>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
